import { useIntersection } from "@mantine/hooks";
import { useEffect } from "react";

import type { ExpertAssistMessage } from "../../../shared-types";

interface UseUnreadMessagesProps {
    scrollRef?: React.RefObject<HTMLDivElement | null>;
    message?: ExpertAssistMessage;
    currentSessionId: string;
    setIsMessageUnread: (sessionId: string, messageId: string, isUnread: boolean) => void;
}

interface MessageIntersection {
    messageIntersectionRef: (node: HTMLDivElement | null) => void;
}

export function useUnreadMessages({
    scrollRef,
    message,
    currentSessionId,
    setIsMessageUnread,
}: UseUnreadMessagesProps): MessageIntersection {
    const { ref: messageIntersectionRef, entry } = useIntersection({
        root: scrollRef?.current,
        threshold: 1,
    });

    useEffect(() => {
        if (entry?.isIntersecting && message?.isUnread) {
            setIsMessageUnread(currentSessionId, message.id, false);
        }
    }, [entry?.isIntersecting, message?.isUnread, message?.id, setIsMessageUnread, currentSessionId]);

    return {
        messageIntersectionRef,
    };
}
